import { Alert } from "@mui/material";
import * as React from "react";
import { MessageContainer } from "source/components/framework/Message/MessageContainer";
import { MessageListContainer } from "source/components/framework/Message/MessageListContainer";
import { Translations } from "ui/Scripts/source/models/translations";
import { IWhistleBlowEditItemMessage } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditItemMessage";
import * as whistleBlowService from "../../../models/services/whistleBlowService";
import { WhistleBlowEditDialogMessageListLine } from "../WhistleBlowEditDialogMessageListLine";
import { WhistleBlowEditDialogMessageListNew } from "../WhistleBlowEditDialogMessageListNew";

//WhistleBlowEditDialogMessageList
export interface IWhistleBlowEditDialogMessageListProp {
    classes?: string;
    whistleBlowId: string;
    internalMessages: boolean;
    maxAttachmentsTotalSize: number;
    isReadOnly: boolean;
    messages: IWhistleBlowEditItemMessage[];
    onWhistleBlowMessageSaved: (internal: boolean, newMessage: IWhistleBlowEditItemMessage) => void;
    onWhistleBlowMessageRead: (internal: boolean, id: string) => void;
}

interface IWhistleBlowEditDialogMessageListState {
    selectedId: string;
    observer: IntersectionObserver;
}

export class WhistleBlowEditDialogMessageList extends React.Component<IWhistleBlowEditDialogMessageListProp, IWhistleBlowEditDialogMessageListState> {
    private messagesContainerDiv = React.createRef<HTMLDivElement>();
    private readReceiptProcessingIds: string[] = [];
    private readReceiptProcessedIds: string[] = [];

    intersectionCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        const props = this.props;
        for (const entry of entries) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.75) continue;
            const line = entry.target as HTMLDivElement;
            if (!line) continue;
            //line.style.backgroundColor = "#FFD800"
            const id = line.getAttribute("data-id");
            if (!id) return;
            const item = this.props.messages.find(i => i.id === id);
            if (!item || item.myMessage || item.isRead) continue;
            const processing = this.readReceiptProcessingIds.indexOf(id) > -1;
            if (processing) continue;
            const processed = this.readReceiptProcessedIds.indexOf(id) > -1;
            if (processed) continue;
            this.readReceiptProcessingIds.push(id);
            whistleBlowService.sendWhistleBlowMessageReadReceipts(this.props.whistleBlowId, [id], this.props.internalMessages)
                .then(result => {
                    if (result) {
                        this.readReceiptProcessedIds.push(id);
                        props.onWhistleBlowMessageRead(props.internalMessages, id);
                    }
                })
                .finally(() => {
                    this.readReceiptProcessingIds = this.readReceiptProcessingIds.filter(i => i !== id);
                });
        }
    };

    createObserver = (): IntersectionObserver => {
        const observer = new IntersectionObserver(this.intersectionCallback, {
            root: this.messagesContainerDiv.current,
            rootMargin: "0px",
            threshold: 0.9
        });
        this.setState({
            observer
        });
        return observer;
    };

    removeObserver = () => {
        const state = this.state;
        if (!state.observer) return;
        state.observer.disconnect();
        this.setState({
            observer: null
        });
    };

    scrollToBottom = () => {
        this.messagesContainerDiv.current.scrollTo({
            top: this.messagesContainerDiv.current.scrollHeight,
            left: 0,
            behavior: "auto"
        });
    };

    constructor(props) {
        super(props);
        this.state = {
            observer: null,
            selectedId: null
        };
    }

    componentDidMount(): void {
        //Observer
        this.createObserver();
        this.scrollToBottom();
    }

    componentWillUnmount(): void {
        //Observer
        this.removeObserver();
    }
    
    handleMessageClick = (id: string) => {
        this.setState({
            selectedId: id
        });
    };

    handleSetMessagesContainerMargin = (margin: number) => {
        if (!this.messagesContainerDiv) return;
        this.messagesContainerDiv.current.style.marginBottom = (margin).toString(10) + "px";
    };

    handleWhistleBlowMessageSaved = (item: IWhistleBlowEditItemMessage) => {
        const props = this.props;
        props.onWhistleBlowMessageSaved(props.internalMessages, item);
        window.setTimeout(() => {
            this.scrollToBottom();
        }, 50);
    };

    render() {
        const props = this.props;
        const state = this.state;
        const messages = props.messages;
        return (
            <MessageContainer>
                <MessageListContainer ref={this.messagesContainerDiv}>
                    {!props.isReadOnly && messages.length < 1 &&
                                <Alert severity="info">{Translations.WhistleBlowDoesNotContainAnyMessage}</Alert>
                    }
                    {messages.map((message) =>
                        <WhistleBlowEditDialogMessageListLine
                            key={message.id}
                            observer={state.observer}
                            message={message}
                            selectedId={state.selectedId}
                            onClick={this.handleMessageClick}
                        />
                    )}
                </MessageListContainer>
                <WhistleBlowEditDialogMessageListNew
                    isReadOnly={props.isReadOnly}
                    whistleBlowId={props.whistleBlowId}
                    internalMessages={props.internalMessages}
                    maxAttachmentsTotalSize={props.maxAttachmentsTotalSize}
                    onSetMessagesContainerMargin={this.handleSetMessagesContainerMargin}
                    onWhistleBlowMessageSaved={this.handleWhistleBlowMessageSaved}
                />
            </MessageContainer>
        );
    }
}